module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getType() === 'v-img') ? _c('v-img', {
    staticClass: "elevation-2",
    attrs: {
      "src": _vm.media.URL,
      "width": _vm.media.width,
      "height": _vm.media.height
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "position-relative text-center"
  }, [(_vm.getType() === 'cld-image') ? _c('cld-image', {
    class: _vm.media.overlay ? 'overlay-main-img' : '',
    attrs: {
      "cloudName": _vm.cldConfig.CLOUD_NAME,
      "public-id": _vm.media.publicID,
      "width": _vm.media.width,
      "loading": _vm.media.trans.loading || ''
    }
  }, [_c('cld-transformation', {
    attrs: {
      "fetch-format": _vm.media.trans.fetchFormat || 'auto',
      "width": _vm.media.trans.width || 720,
      "crop": _vm.media.trans.crop || 'scale'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [(_vm.getType() === 'cld-image') ? _c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.getType() === 'cld-video') ? _c('div', {
    class: (_vm.media.className) || ''
  }, [_c('div', [_c('video', {
    class: ("cld-video-player " + (_vm.media.postView ? 'post-view' : '') + " cld-fluid"),
    attrs: {
      "id": ("cld-player-" + (_vm.media.videoID)),
      "data-cld-public-id": _vm.media.publicID,
      "controls": ""
    }
  })]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.getType() === 'native-image') ? _c('v-img', {
    staticClass: "custom-preview-img grey lighten-2",
    attrs: {
      "src": _vm.previewMedia
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [(_vm.getType() === 'native-image') ? _c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getType() === 'native-video'),
      expression: "getType() === 'native-video'"
    }],
    class: (_vm.media.className) || ''
  }, [_c('div', {
    class: (_vm.media.vdoClassName) || ''
  }, [_c('video', {
    staticClass: "custom-preview-video",
    attrs: {
      "id": _vm.mediaFileName,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")])]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getType() === 's3-video'),
      expression: "getType() === 's3-video'"
    }],
    class: (_vm.media.className) || ''
  }, [_c('div', {
    class: (_vm.media.vdoClassName) || ''
  }, [_c('video', {
    staticClass: "custom-preview-video",
    attrs: {
      "id": _vm.mediaFileName,
      "src": _vm.media.URL,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")])]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.getType() === 's3-image') ? _c('div', [_c('v-img', {
    staticClass: "custom-preview-img grey lighten-2",
    attrs: {
      "src": _vm.media.URL
    }
  }), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getType() === 'iframe') ? _c('iframe', {
    class: _vm.media.className || '',
    attrs: {
      "width": _vm.media.width,
      "height": _vm.media.height,
      "src": _vm.media.URL,
      "allow": "autoplay",
      "scrolling": "no",
      "seamless": "",
      "allowFullScreen": ""
    }
  }) : (_vm.getType() === 'driveCustomView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.media.URL,
      "darkTheme": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6adc0f7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/CustomMediaV2.vue
// module id = 2174
// module chunks = 0